import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import HomePage from "./pages/HomePage";
import Login from "./pages/Login";
import DbElasticPool from "../features/accelerus/pages/DbElasticPool";
import WorkerMaintenance from "../features/accelerus/pages/WorkerMaintenance";
import WorkerScaling from "../features/accelerus/pages/WorkerScaling";
import MigrationCreate from "../features/gradexpert/pages/MigrationCreate";
import MigrationDetails from "../features/gradexpert/pages/MigrationDetails";
import MigrationList from "../features/gradexpert/pages/MigrationList";
import PowerOnOff from "../features/power-control/pages/PowerOnOff";
import DbBackupRetention from "../features/xuno/pages/DbBackupRetention";
import DbBackupSchedule from "../features/xuno/pages/DbBackupSchedule";
import BlobArchive from "../features/xuno/pages/BlobArchive";
import DbServerScaling from "../features/xuno/pages/DbServerScaling";
import Loading from "../shared/ui/Loading";

const AppRoutes = () => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  if (inProgress !== InteractionStatus.None) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />

      {/* Accelerus */}
      <Route path="/accelerus/development/on-off" element={<PowerOnOff key="accelerus-dev-on-off" product="accelerus" />} />
      <Route path="/accelerus/development/worker-scaling" element={<WorkerScaling env="AccelerusDev" />} />
      <Route path="/accelerus/development/worker-maintenance" element={<WorkerMaintenance env="dev" />} />
      <Route path="/accelerus/production/elastic-pool" element={<DbElasticPool />} />
      <Route path="/accelerus/production/worker-scaling" element={<WorkerScaling env="AccelerusProd" />} />
      <Route path="/accelerus/production/worker-maintenance" element={<WorkerMaintenance env="prod" />} />

      {/* Xuno */}
      <Route path="/xuno/production/blob-archive" element={<BlobArchive />} />
      <Route path="/xuno/production/backup-schedule" element={<DbBackupSchedule />} />
      <Route path="/xuno/production/backup-retention" element={<DbBackupRetention />} />
      <Route path="/xuno/production/server-scaling" element={<DbServerScaling />} />

      {/* BPOS */}
      <Route path="/bpos/development/on-off" element={<PowerOnOff key="bpos-dev-on-off" product="bpos" />} />

      {/* GradeXpert */}
      <Route
        path="/gradexpert/development/on-off/staging"
        element={
          <PowerOnOff
            key="gradexpert-dev-staging-on-off"
            product="gradexpert"
            rowKeyFilter="staging"
          />
        }
      />
      <Route
        path="/gradexpert/development/on-off/16022"
        element={
          <PowerOnOff
            key="gradexpert-dev-16022-on-off"
            product="gradexpert"
            rowKeyFilter="16022"
          />
        }
      />
      <Route path="/gradexpert/production/migration/list" element={<MigrationList />} />
      <Route path="/gradexpert/production/migration/create" element={<MigrationCreate />} />
      <Route path="/gradexpert/production/migration/detail" element={<MigrationDetails />} />

      {/* Unknown paths go home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
